import { Answer, IAnswer } from 'app/constants/schemas/Answer';
import { CommonText, ICommonText } from 'app/constants/schemas/CommonText';
import { Text, IText } from 'app/constants/schemas/Text';

export interface IAttributes {
  cohortId: string | null;
  embedded: boolean | null;
  quizType: string;
  prompt: string | null;
}

export interface IAssociations {
  answers: IAnswer[];
  commonTeacherNoteText: ICommonText | null;
  customTeacherNoteText: IText | null;
}

export const attributes = {
  cohortId: 'string',
  embedded: 'boolean',
  quizType: {
    type: 'string',
    notNull: true,
  },
  prompt: 'string',
};

export const associations = {
  answers: [Answer],
  commonTeacherNoteText: {
    type: CommonText,
    shared: true,
  },
  customTeacherNoteText: Text,
};
